import { render, staticRenderFns } from "./OwnerDetails.vue?vue&type=template&id=1c3c4baf&"
import script from "./OwnerDetails.vue?vue&type=script&lang=js&"
export * from "./OwnerDetails.vue?vue&type=script&lang=js&"
import style0 from "./OwnerDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports